const state = {
    budgets: [],
    budgetList: [],
    budgetId: [],
    loading: false
};

export default state;